import _ from 'lodash';
import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import CartaPorteRegimenesAduanerosForm from './CartaPorteRegimenesAduanerosForm';
import CartaPorteRegimenesAduanerosList from './CartaPorteRegimenesAduanerosList';

class CartaPorteRegimenesAduanerosManager extends Component {
  state = {};

  handleOnAdd = (data) => {
    const { RegimenesAduaneros = {} } = this.props.data;
    const { RegimenAduaneroCCP = [] } = RegimenesAduaneros;
    const { RegimenAduanero } = data;

    if (RegimenAduaneroCCP.length === 10) {
      return;
    }

    const found = RegimenAduaneroCCP.filter((item) => item.RegimenAduanero === RegimenAduanero).length > 0;

    if (found) {
      return;
    }

    const newData = RegimenAduaneroCCP.concat([
      {
        id: Uuid.v4(),
        ...data,
      },
    ]);

    this.handleOnListChange(newData);
  };

  handleOnAddFile = (data) => {
    const { RegimenesAduaneros = {} } = this.props.data;
    const { RegimenAduaneroCCP = [] } = RegimenesAduaneros;

    let newData = _.map(data, (item) => {
      item.id = Uuid.v4();

      return item;
    });

    newData = RegimenAduaneroCCP.concat(newData);

    this.handleOnListChange(newData);
  };

  handleOnListChange = (data) => {
    const event = { isValid: true, name: 'regimenesaduaneros' };

    const newData = {
      ...this.props.data,
      RegimenesAduaneros: {
        RegimenAduaneroCCP: data,
      },
    };

    this.props.onChange(newData, event);
  };

  handleOnEdit = (item) => {
    this.setState(
      {
        data: { ...item },
      },
      () => {
        this.setState({
          data: undefined,
        });
      }
    );
  };

  handleOnDelete = () => {
    const event = { isValid: false, name: 'regimenesaduaneros' };

    this.props.onChange(
      {
        ...this.props.data,
        RegimenesAduaneros: {
          RegimenAduaneroCCP: [],
        },
      },
      event
    );
  };

  render() {
    const { data } = this.state;
    const { RegimenesAduaneros = {} } = this.props.data;
    const { RegimenAduaneroCCP = [] } = RegimenesAduaneros;

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Regimenes Aduaneros</strong>
        </div>

        <div className="section">
          <div className="pt-2">
            <CartaPorteRegimenesAduanerosForm
              data={data}
              onAdd={this.handleOnAdd}
            />
          </div>

          <div className="pt-2">
            <CartaPorteRegimenesAduanerosList
              data={RegimenAduaneroCCP}
              onEdit={this.handleOnEdit}
              onChange={this.handleOnListChange}
            />
          </div>

          <Row>
            <Col>
              <Button
                variant="danger"
                disabled={RegimenAduaneroCCP.length === 0}
                onClick={this.handleOnDelete}
              >
                Eliminar regimenes
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default CartaPorteRegimenesAduanerosManager;
